// Status tabs component for issue filtering
// Reference: spec.md US2 - view issues organized by status tabs

interface StatusCounts {
  in_progress?: number;
  your_tasks?: number;
  completed?: number;
  reported?: number;
}

interface StatusTabsProps {
  activeTab: string;
  onChange: (tab: string) => void;
  counts?: StatusCounts | undefined;
}

interface Tab {
  id: string;
  label: string;
  countKey: keyof StatusCounts;
}

const TABS: Tab[] = [
  { id: 'in_progress', label: 'In Progress', countKey: 'in_progress' },
  { id: 'your_tasks', label: 'Your Tasks', countKey: 'your_tasks' },
  { id: 'completed', label: 'Completed', countKey: 'completed' },
  { id: 'reported', label: 'Reported by You', countKey: 'reported' },
];

export function StatusTabs({ activeTab, onChange, counts }: StatusTabsProps) {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Issue tabs">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          const count = counts?.[tab.countKey];

          return (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${
                  isActive
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
              aria-current={isActive ? 'page' : undefined}
            >
              {tab.label}
              {count !== undefined && count > 0 && (
                <span
                  className={`
                    ml-2 py-0.5 px-2 rounded-full text-xs
                    ${isActive ? 'bg-primary-100 text-primary-600' : 'bg-gray-100 text-gray-600'}
                  `}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}

export default StatusTabs;
